import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import GroupsEvents from './GroupsEvents';

import GroupsDetailsSectionInfo from './details/sections/GroupsDetailsSectionInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<GroupsDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="grps_descriptionhtml"
				value={props.model.grps_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
		</>
	),
	events: GroupsEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
